import StoredLayout from 'layouts/StoredLayout';
import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';
import { Row as FlexRow, Col as FlexCol } from 'react-flexbox-grid';
import DialogModal from 'cyder/modals/DialogModal';
import React from 'react';
import { connect } from 'react-redux';
import history from '../../../../history';
import { Input, Row, Col, Form, Button, FormGroup, Label } from 'reactstrap';

import { save, update, remove, load } from 'actions/staff/election/scrutineer/action.js';

import 'css/forms/default-forms.css';

class AddPage extends React.Component {
    constructor(props) {
        super(props);

        this.back = this.back.bind(this);
        this.emailChange = this.emailChange.bind(this);

        this.designationChange = this.designationChange.bind(this);

        this.organizationNameChange = this.organizationNameChange.bind(this);

        this.fullNameChange = this.fullNameChange.bind(this);

        this.save = this.save.bind(this);
        this.remove = this.remove.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);

        this.modalToggle = this.modalToggle.bind(this);
        this.showModal = this.showModal.bind(this);
        this.showLoading = this.showLoading.bind(this);
        this.modalAction = this.modalAction.bind(this);
        this.negativeModalAction = this.negativeModalAction.bind(this);

        this.state = {
            loading: false,
            data: {
                email: '',

                designation: '',

                organizationName: '',

                fullName: '',
            },
            modal: {
                showModal: false,
                modalMessage: '',
                modalHeader: '',
                positiveButtonHide: true,
                negativeButtonHide: true,
                type: 'save',
            },
        };
    }
    back() {
        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/scrutineers`);
    }
    modalAction() {
        if (this.state.modal.type === 'deleteConfirm') {
            this.remove();
        }
    }
    negativeModalAction() {
        this.modalToggle();
    }
    showLoading(show) {
        this.setState({
            loading: show,
        });
    }
    modalToggle() {
        var modal = this.state.modal;
        modal.showModal = !modal.showModal;
        this.setState({
            modal,
        });
    }
    showModal(header, message, type, positiveButtonHide, negativeButtonHide) {
        var modal = this.state.modal;
        modal.showModal = true;
        modal.modalHeader = header;
        modal.type = type;
        modal.positiveButtonHide = positiveButtonHide;
        modal.negativeButtonHide = negativeButtonHide;
        modal.modalMessage = message;
        this.setState({
            modal,
        });
    }
    componentDidMount() {
        this.showLoading(true);
        var id = null;
        try {
            id = this.props.match.params.id;
        } catch (e) {}
        if (id != null && id > 0) {
            this.props
                .load(id)
                .then(res => {
                    this.showLoading(false);
                    if (res.error || res.data == null || res.data.id == null) {
                        this.showModal('Error', res.message, 'load', true, true);
                    } else {
                        this.setState({
                            data: res.data,
                        });
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'load', true, true);
                });
        } else {
            this.setState({
                data: {
                    email: '',

                    designation: '',

                    organizationName: '',

                    fullName: '',
                },
            });
            this.showLoading(false);
        }
    }
    prepareDataBeforeSave(data) {
        var newData = data;
        return newData;
    }
    save() {
        var data = this.prepareDataBeforeSave(this.state.data);
        this.showLoading(true);
        data.electionId = this.props.match.params.electionid;
        if (data.id == null || data.id === 0 || data.id === '') {
            this.props
                .save(data)
                .then(res => {
                    this.showLoading(false);
                    if (res.error) {
                        this.showModal('Error', res.message, 'save', true, true);
                    } else {
                        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/scrutineers`);
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'save', true, true);
                });
        } else {
            this.props
                .update(data)
                .then(res => {
                    this.showLoading(false);
                    if (res.error) {
                        this.showModal('Error', res.message);
                    } else {
                        history.replace(`/staff/elections/view/${this.props.match.params.electionid}/scrutineers`, 'update', true, true);
                    }
                })
                .catch(error => {
                    this.showLoading(false);
                    this.showModal('Error', error.message, 'update', true, true);
                });
        }
    }
    removeConfirm() {
        this.showModal('Confirmation', 'Are you sure you want to delete this record?', 'deleteConfirm', false, false);
    }
    remove() {
        var data = this.state.data;
        this.props
            .remove(data.id)
            .then(res => {
                history.replace(`/staff/elections/view/${this.props.match.params.electionid}/scrutineers`);
            })
            .catch(error => {
                this.showModal('Error', error.message, 'delete', true, true);
            });
    }
    emailChange(e) {
        var data = this.state.data;
        data.email = e.target.value;
        this.setState({ data });
    }

    designationChange(e) {
        var data = this.state.data;
        data.designation = e.target.value;
        this.setState({ data });
    }

    organizationNameChange(e) {
        var data = this.state.data;
        data.organizationName = e.target.value;
        this.setState({ data });
    }

    fullNameChange(e) {
        var data = this.state.data;
        data.fullName = e.target.value;
        this.setState({ data });
    }

    render() {
        return this.state.loading ? (
            <LoadingSpinner />
        ) : (
            <div className="page-widget">
                <DialogModal
                    modalAction={this.modalAction}
                    negativeButtonAction={this.negativeModalAction}
                    actionToggleExternal={this.modalToggle}
                    modalOpen={this.state.modal.showModal}
                    positiveButtonHide={this.state.modal.positiveButtonHide}
                    negativeButtonHide={this.state.modal.negativeButtonHide}
                    modalBody={this.state.modal.modalMessage}
                    modalHeader={this.state.modal.modalHeader}
                />
                <Form style={{ paddingBottom: '20px' }}>
                    <Form>
                        <Row className="mb-2">
                            <Col xs={12} className="d-flex">
                                <Button className="primary-btn-style-outline" onClick={this.back}>
                                    <i className="material-icons align-text-bottom">chevron_left</i>
                                    Back
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <hr />
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="fullName">Full Name</Label>{' '}
                                <Input
                                    type="text"
                                    name="fullName"
                                    id="fullName"
                                    value={this.state.data.fullName}
                                    placeholder=""
                                    onChange={this.fullNameChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="designation">Designation</Label>{' '}
                                <Input
                                    type="text"
                                    name="designation"
                                    id="designation"
                                    value={this.state.data.designation}
                                    placeholder=""
                                    onChange={this.designationChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>
                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="email">Email</Label>{' '}
                                <Input
                                    type="text"
                                    name="email"
                                    id="email"
                                    value={this.state.data.email}
                                    placeholder=""
                                    onChange={this.emailChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>

                    <Row className="mb-2">
                        {' '}
                        <Col xs={12}>
                            {' '}
                            <FormGroup>
                                {' '}
                                <Label for="organizationName">Organisation Name</Label>{' '}
                                <Input
                                    type="text"
                                    name="organizationName"
                                    id="organizationName"
                                    value={this.state.data.organizationName}
                                    placeholder=""
                                    onChange={this.organizationNameChange}
                                />{' '}
                            </FormGroup>{' '}
                        </Col>{' '}
                    </Row>

                    <hr />
                    <FlexRow between="xs">
                        <FlexCol xs={2}>
                            <Button className="ml-2 align-middle primary-btn-style" onClick={this.save}>
                                Save
                            </Button>
                        </FlexCol>
                        {this.state.data.id > 0 ? (
                            <FlexCol xs={2}>
                                <Button className="ml-2 align-middle primary-btn-style" onClick={this.removeConfirm}>
                                    Delete
                                </Button>
                            </FlexCol>
                        ) : (
                            <div />
                        )}
                    </FlexRow>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        save: data => {
            return dispatch(save(data));
        },
        update: data => {
            return dispatch(update(data));
        },
        remove: id => {
            return dispatch(remove(id));
        },
        load: id => {
            return dispatch(load(id));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(AddPage));
